import * as React from 'react';
import { IPlanningEntry } from '../models';
import { useData } from '../core/context/ProvidersContext';

export function usePlanning(bacIds?: number[]): {
  entries: IPlanningEntry[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
} {
  const data = useData();
  const [entries, setEntries] = React.useState<IPlanningEntry[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  const idsKey = bacIds ? bacIds.join(',') : '';

  const refresh = React.useCallback(() => {
    setLoading(true);
    setError(null);
    data.getPlanningEntries(bacIds)
      .then(setEntries)
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, idsKey]);

  React.useEffect(() => { refresh(); }, [refresh]);

  return { entries, loading, error, refresh };
}
